module.exports = __webpack_public_path__ + "img/2021_1_1_among_us.feac4528.jpg";